/* Built In Imports */
/* External Imports */
import { Box, Heading } from '@chakra-ui/react';

/* Internal Imports */

/* Styles */
/* Services */

/**
 * Renders BlogTableOfContentsSection Component
 *
 * @param {object} sectionContent
 * @returns {ReactElement} BlogTableOfContentsSection Component
 */

const BlogTableOfContentsSection = ({ sectionContent }) => {
  return (
    <>
      <Box pos="relative" width="100%" m="0 auto">
        <Heading
          as="h3"
          mt="40px"
          id={`${sectionContent?.key}`}
          fontFamily="var(--FedraSerifDisplay-Regular)"
          fontWeight="400"
          fontSize={{ base: '24px', md: '36px' }}
          color="#010509"
          mb="20px"
          lineHeight="1.1em"
        >
          {sectionContent?.title}
        </Heading>
      </Box>
    </>
  );
};

export default BlogTableOfContentsSection;
